import { Link } from "react-router-dom";
import { EnvelopeFill, TelephoneFill, GeoAltFill, HeartFill } from "react-bootstrap-icons";
import petrollLogo from "../assets/images/Petroll Logo small.png";

const Footer = () => {
  return (
    <footer className="pf-footer">
      <div className="pf-container">

        {/* ===== BRAND ===== */}
        <div className="pf-brand-row">
          <Link to="https://petroll.co" className="pf-logo-link">
            <img src={petrollLogo} alt="Petroll Logo" className="pf-logo" />
          </Link>
          <p className="pf-tagline">
            A modern platform to identify, track, and manage your pets across
            family, friends, and caregivers.
          </p>
        </div>

        {/* ===== COLUMNS ===== */}
        <div className="pf-columns">

          <div className="pf-col">
            <h6 className="pf-col-heading">Company</h6>
            <Link to="https://petroll.co/about" className="pf-link">About</Link>
            <Link to="https://petroll.co" className="pf-link">Features</Link>
            <Link to="#" className="pf-link">Pricing</Link>
            <Link to="#" className="pf-link">Careers</Link>
          </div>

          <div className="pf-col">
            <h6 className="pf-col-heading">Legal</h6>
            <Link to="https://petroll.co/safety" className="pf-link">Privacy Policy</Link>
            <Link to="https://petroll.co/terms" className="pf-link">Terms</Link>
            <Link to="https://petroll.co/child-safety" className="pf-link">Child Safety</Link>
          </div>

          <div className="pf-col">
            <h6 className="pf-col-heading">Contact</h6>
            <div className="pf-contact-row">
              <EnvelopeFill className="pf-icon" />
              <span>support@petroll.co</span>
            </div>
            <div className="pf-contact-row">
              <TelephoneFill className="pf-icon" />
              <span>+1 (555) 123-4567</span>
            </div>
            <div className="pf-contact-row pf-contact-row--top">
              <GeoAltFill className="pf-icon" />
              <span>
                Paraa Tech Inc.
                <br />
                San Francisco, CA
              </span>
            </div>
          </div>

        </div>

        {/* ===== BOTTOM ===== */}
        <div className="pf-bottom">
          <span>© 2025 Petroll.co — Paraa Tech Inc.</span>
          <div className="pf-bottom-links">
            <Link to="https://petroll.co/terms" className="pf-link pf-link--muted">Terms</Link>
            <Link to="https://petroll.co/safety" className="pf-link pf-link--muted">Privacy</Link>
          </div>
        </div>

        {/* ===== SMALL NOTE ===== */}
        <div className="pf-note">
          Made with <HeartFill className="pf-heart" /> for pets
        </div>

      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@500&family=Inter:wght@400;500;600&display=swap');

        .pf-footer {
          background: #0D1210;
          color: #C7CFCA;
          font-family: 'Inter', sans-serif;
          border-top: 1px solid #253530;
          padding: 56px 0 32px;
        }

        .pf-container {
          max-width: 1140px;
          margin: 0 auto;
          padding: 0 24px;
          display: flex;
          flex-direction: column;
          gap: 44px;
        }

        .pf-brand-row {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 12px;
        }

        .pf-logo-link {
          display: inline-block;
          text-decoration: none;
        }

        .pf-logo {
          height: 28px;
          object-fit: contain;
        }

        .pf-tagline {
          color: #8B978F;
          font-size: 14px;
          line-height: 1.6;
          max-width: 480px;
          margin: 0;
        }

        .pf-columns {
          display: flex;
          flex-direction: column;
          gap: 32px;
          border-top: 1px solid #1D2A25;
          padding-top: 36px;
        }

        .pf-col {
          display: flex;
          flex-direction: column;
          gap: 11px;
          flex: 1;
        }

        .pf-col-heading {
          font-family: 'IBM Plex Mono', monospace;
          font-size: 11px;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: #D98B2B;
          margin: 0 0 4px;
        }

        .pf-link {
          color: #C7CFCA;
          text-decoration: none;
          font-size: 14px;
          transition: color 0.15s ease;
          width: fit-content;
        }

        .pf-link:hover {
          color: #D98B2B;
          text-decoration: underline;
        }

        .pf-link--muted {
          color: #8B978F;
          font-size: 13px;
        }

        .pf-contact-row {
          display: flex;
          align-items: center;
          gap: 9px;
          font-size: 14px;
        }

        .pf-contact-row--top {
          align-items: flex-start;
        }

        .pf-contact-row--top svg {
          margin-top: 3px;
        }

        .pf-icon {
          color: #D98B2B;
          flex-shrink: 0;
        }

        .pf-bottom {
          display: flex;
          flex-direction: column;
          gap: 14px;
          justify-content: space-between;
          align-items: flex-start;
          border-top: 1px solid #1D2A25;
          padding-top: 22px;
          font-size: 13px;
          color: #8B978F;
        }

        .pf-bottom-links {
          display: flex;
          gap: 22px;
        }

        .pf-note {
          text-align: center;
          font-size: 12.5px;
          color: #6C776F;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 4px;
        }

        .pf-heart {
          color: #D98B2B;
        }

        @media (min-width: 768px) {
          .pf-columns { flex-direction: row; }
          .pf-bottom { flex-direction: row; align-items: center; }
        }
      `}</style>
    </footer>
  );
};

export default Footer;